import React, {useState, useEffect, useRef} from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { useSelector, useDispatch } from 'react-redux'
import {
    signatureSelector,
    setChoice,
    setText,
    setImage,
    setDraw,
    setQrCode,
    setParaphe,
    setMode
} from "../../../../../services/reduxSlices/SignatureSlice";
import './Step2.css'

/**
 * Etape 2 (Signature) de la fenêtre modale seul signataire
 */
export default function Step2 () {
    const signature = useSelector(signatureSelector)
    const dispatch = useDispatch()

    const signatureRef = useRef({})

    const handleDisplayChoiceParameters = (choice) => signature.choice === choice  ? 'd-flex align-items-center' : 'd-none'
    const handleSetSignatureImage = (e) => dispatch(setImage(URL.createObjectURL(e.target.files[0])))

    const handleSetSignatureDraw = () => {
        dispatch(setDraw(signatureRef.current.getTrimmedCanvas().toDataURL("image/png")))
    }

    const handleClearSignatureDraw = () => {
        signatureRef.current.clear()
        dispatch(setDraw(null))
    }

    const handleClearImage = () => {
        document.querySelector("#signature-image").value = null
        dispatch(setImage(null))
    }

    return <div className='d-flex flex-column'>
        <div className='d-flex align-items-center mb-5'>
            <div className="form-check form-check-custom form-check-solid">
                <input className="form-check-input" type="radio" value="text" id="text" name='choice' defaultChecked onClick={() => dispatch(setChoice('text'))} />
                <label className="form-check-label" htmlFor="text">
                    Définition
                </label>
            </div>

            <div className="form-check form-check-custom form-check-solid mx-5">
                <input className="form-check-input" type="radio" value="image" id="image" name='choice' onClick={() => dispatch(setChoice('image'))}/>
                <label className="form-check-label" htmlFor="image">
                    Charger une image
                </label>
            </div>

            <div className="form-check form-check-custom form-check-solid">
                <input className="form-check-input" type="radio" value="draw" id="draw" name='choice' onClick={() => dispatch(setChoice('draw'))}/>
                <label className="form-check-label" htmlFor="draw">
                    Zone de signature
                </label>
            </div>
        </div>

        <div className="py-5">
            <div className="d-flex align-items-center">
                <div className={handleDisplayChoiceParameters('text')}>
                    <input type="search" className="form-control" defaultValue={signature.text} onChange={e => dispatch(setText(e.target.value))} />
                    <label style={{ fontFamily: 'Dancing Script', fontSize: '3rem', marginLeft: '1em' }}>{signature.text}</label>
                </div>
            </div>

            <div className="d-flex align-items-center">
                <div className={handleDisplayChoiceParameters('image')}>
                    <input type="file" id="signature-image" className="form-control" accept='image/*' onChange={handleSetSignatureImage} />

                    <div className="position-relative" id="image-container">
                        {signature.image && <img src={signature.image} alt="Image de signature" width="100" className='ms-5' />}
                        {signature.image && <button type='button' title="Retirer cette image" 
                            style={{ top: 0, right: 0, width: '10px', height: '10px', padding: '15px' }} 
                            className='btn btn-danger ms-5 rounded-circle justify-content-center align-items-center position-absolute' 
                            onClick={() => handleClearImage()}>X
                        </button>}
                    </div>
                </div>
            </div>

            <div className="d-flex align-items-center">
                <div className={handleDisplayChoiceParameters('draw')}>
                    <div className='rounded' style={{ border: '1px solid #E4E6EF' }} id="canvas">
                        <SignatureCanvas
                            ref={signatureRef}
                            canvasProps={{ width: 400, height: 100 }}
                            onEnd={() => handleSetSignatureDraw()}
                        />
                    </div>

                    <div className="ms-5 d-flex flex-column">
                        <button type='button' className='btn btn-primary' onClick={() => handleClearSignatureDraw()}>Effacer</button>
                    </div>
                </div>
            </div>
        </div>

        <div className="mt-5">
            <div className='d-flex align-items-center mb-5'>
                <div className="form-check form-check-custom form-check-solid">
                    <input className="form-check-input" type="checkbox" value="paraphe" id="paraphe" name='option' onClick={() => dispatch(setParaphe(!signature.paraphe))} />
                    <label className="form-check-label" htmlFor="paraphe">
                        Paraphe
                    </label>
                </div>

                <div className="form-check form-check-custom form-check-solid mx-5">
                    <input className="form-check-input" type="checkbox" value="qrcode" id="qrcode" name='option' onClick={() => dispatch(setQrCode(!signature.qrCode))} />
                    <label className="form-check-label" htmlFor="qrcode">
                        QR Code
                    </label>
                </div>
            </div>
        </div>
    </div>
}
